import { useSearchParams } from "react-router-dom";
import { SlidersHorizontal } from "lucide-react";

const GUEST_OPTIONS = [
  { value: "", label: "Any guests" },
  { value: "1", label: "1 guest" },
  { value: "2", label: "2 guests" },
  { value: "4", label: "4+ guests" },
  { value: "6", label: "6+ guests" },
];

const PRICE_OPTIONS = [
  { value: "", label: "Any price" },
  { value: "5000", label: "Under ₹5,000" },
  { value: "10000", label: "Under ₹10,000" },
  { value: "15000", label: "Under ₹15,000" },
];

const SORT_OPTIONS = [
  { value: "sortOrder", label: "Featured" },
  { value: "price-asc", label: "Price: Low to High" },
  { value: "price-desc", label: "Price: High to Low" },
  { value: "size-desc", label: "Largest first" },
];

const selectClass =
  "rounded-full border border-gray-200 bg-white px-4 py-2 text-sm text-metro-ink outline-none transition focus:border-metro-green-800 focus:ring-2 focus:ring-metro-green-800/10 cursor-pointer";

export default function RoomFilters() {
  const [params, setParams] = useSearchParams();

  const set = (key: string, val: string) => {
    const next = new URLSearchParams(params);
    if (val) next.set(key, val);
    else next.delete(key);
    setParams(next);
  };

  return (
    <div className="flex flex-wrap items-center gap-3">
      <span className="flex items-center gap-1.5 text-sm font-medium text-metro-ink-muted">
        <SlidersHorizontal size={15} />
        Filter
      </span>

      {/* Guests */}
      <select
        className={selectClass}
        value={params.get("guests") ?? ""}
        onChange={(e) => set("guests", e.target.value)}
        aria-label="Filter by guests"
      >
        {GUEST_OPTIONS.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>

      {/* Max price */}
      <select
        className={selectClass}
        value={params.get("maxPrice") ?? ""}
        onChange={(e) => set("maxPrice", e.target.value)}
        aria-label="Filter by price"
      >
        {PRICE_OPTIONS.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>

      {/* Sort */}
      <select
        className={selectClass}
        value={params.get("sort") ?? "sortOrder"}
        onChange={(e) => set("sort", e.target.value)}
        aria-label="Sort rooms"
      >
        {SORT_OPTIONS.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>

      {/* Clear */}
      {(params.get("guests") || params.get("maxPrice")) && (
        <button
          type="button"
          onClick={() => setParams({})}
          className="text-xs text-metro-ink-subtle underline-offset-2 hover:underline"
        >
          Clear filters
        </button>
      )}
    </div>
  );
}